import configuration from "@/utils/Config";
import {
  restGetUniqueHandler,
  restPostHandler,
  restUpdateHandler,
} from "@/utils/rest/RestClient";
import { createEffect } from "effector";
import { RevokeCertificateForRenewNowBodyDto } from "@state/onboarding/dto/body/onboarding.revoke.certificate.for.renew.now.body.dto";
import { EcUserDTO } from "@type/core/user/EcUserDTO";
import { PostCertificateUrlBodyDto } from "@/state/onboarding/dto/body/onboarding.post.certificate.url.body.dto";
import { UserInformationHistory } from "@views/core/extranet/onboarding/pages/OBNewInformationPage";
import { SetLastUseOfOldValueBodyDto } from "@state/onboarding/dto/body/onboarding.set.last.use.of.old.value.body.dto";
import { SetConsentDateBodyDto } from "@state/onboarding/dto/body/onboarding.set.consent.date.body.dto";
import { CustomErrorCode } from "@/type/core/api/api.types";

const baseUrl = configuration.backendBaseUrl;
const onboardingLogoutUrl = baseUrl + "/ws/fo/logout/onboarding";
const revokeCertificateForRenewNowUrl =
  baseUrl + "/ws/fo/user/certificate/renewableRevoke";
const certificateUrl = baseUrl + "/ws/fo/user/certificate";
const userInformationHistoryUrl = baseUrl + "/ws/fo/user/informationHistory";
const lastUseOfOldValueUrl = baseUrl + "/ws/fo/user/informationHistory/lastUse";
const consentDateUrl = baseUrl + "/ws/fo/user/informationHistory/consentDate";
const userWithNewValueUrl = baseUrl + "/ws/fo/user/withHistory";
const certificateStatusUrl = baseUrl + "/ws/fo/user/certificate/progress";

export const requestOnboardingLogout = createEffect({
  handler: restGetUniqueHandler<void>(onboardingLogoutUrl),
});

export const requestRevokeCertificateForRenewNow = createEffect({
  handler: restPostHandler<RevokeCertificateForRenewNowBodyDto, EcUserDTO>(
    revokeCertificateForRenewNowUrl,
  ),
});

export const requestPostCertificateUrl = createEffect({
  handler: restPostHandler<
    PostCertificateUrlBodyDto,
    { url: string; customCode?: CustomErrorCode }
  >(certificateUrl),
});

export const requestGetUserInformationHistory = createEffect({
  handler: restGetUniqueHandler<UserInformationHistory>(
    userInformationHistoryUrl,
  ),
});

export const requestSetLastUseOfOldValue = createEffect({
  handler: restPostHandler<SetLastUseOfOldValueBodyDto, UserInformationHistory>(
    lastUseOfOldValueUrl,
  ),
});

export const requestSetConsentDate = createEffect({
  handler: restPostHandler<SetConsentDateBodyDto, UserInformationHistory>(
    consentDateUrl,
  ),
});

export const requestUpdateUserWithNewValue = createEffect({
  handler: restUpdateHandler<object, EcUserDTO>(userWithNewValueUrl),
});

export const requestGetCertificateStatus = createEffect({
  handler: restGetUniqueHandler<{ status: string }>(certificateUrl),
});

export const requestUpdateCertificateStatus = createEffect({
  handler: restGetUniqueHandler<void>(certificateStatusUrl),
});
